import { useState } from 'react';
import { api, useAction } from '../../api/hooks';
import type { Environment } from '../../api/types';
import { Button } from '../../ui/Button';
import { Alert, ErrorAlert } from '../../ui/feedback';

/** Asks GitHub whether Jira can dispatch the environment's workflow. */
export function WorkflowCheck({
  projectKey,
  env,
}: {
  projectKey: string;
  env: Pick<Environment, 'id' | 'deployWorkflow'>;
}) {
  const [result, setResult] = useState<{ ok: boolean; message: string; url?: string } | null>(null);
  const check = useAction(
    () =>
      api.get<{ ok: boolean; message: string; url?: string }>(
        `/projects/${projectKey}/environments/${env.id}/workflow-check`,
      ),
    { onSuccess: setResult },
  );
  if (!env.deployWorkflow) return null;
  return (
    <div className="stack sm">
      <div>
        <Button size="sm" variant="ghost" onClick={() => check.mutate(undefined)} loading={check.isPending}>
          Check workflow on GitHub
        </Button>
      </div>
      {result && (
        <Alert tone={result.ok ? 'success' : 'warning'}>
          {result.message}{' '}
          {result.url && (
            <a href={result.url} target="_blank" rel="noopener noreferrer nofollow">
              Open on GitHub
            </a>
          )}
        </Alert>
      )}
      <ErrorAlert error={check.error} />
    </div>
  );
}
